export default "__VITE_ASSET__Bd1BPbpw__"